export default __webpack_public_path__ + "static/media/WEETH.6d618582.svg";